export default __webpack_public_path__ + "static/media/Iconly-Bold-Edit.707a9dc0.svg";